<!-- 
	This is the dashboard page, it uses the dashboard layout in: 
	"./layouts/Dashboard.vue" .
 -->

<template>
  <div>
    <!-- Counter Widgets -->
    <a-row :gutter="24">
      <a-col
        :span="24"
        :lg="8"
        class="mb-24"
        v-for="(stat, index) in stats"
        :key="index"
      >
        <widgetCounter
          :title="stat.title"
          :value="stat.value"
          :prefix="stat.prefix"
          :suffix="stat.suffix"
          :icon="stat.icon"
          :status="stat.status"
        ></widgetCounter>
      </a-col>
    </a-row>
    <!--<serverInfoTable class="mb-24" />-->
    <aclTable ref="aclTable" class="mb-24" />
  </div>
</template>

<script>
import axios from "axios";
import widgetCounter from "../components/Widgets/WidgetCounter";
import aclTable from "../components/Inventories/ACLTable";
import serverInfoTable from "../components/Inventories/ServerInfoTable";
import tools from "../utils/tools";

// Counter Widgets stats
let stats = [
  {
    title: "Total Users",
    value: 0,
    prefix: "",
    suffix: ""
  },
  {
    title: "Total Guests",
    value: 0,
    prefix: "",
    suffix: ""
  },
  {
    title: "Total Rooms",
    value: 0,
    prefix: "",
    suffix: ""
  }
];

export default {
  //
  //
  //
  components: {
    widgetCounter,
    aclTable,
    serverInfoTable
  },
  //
  //
  //
  data() {
    return {
      stats
    };
  },
  //
  //
  //
  beforeCreate() {
    if (!tools.isLogin()) this.$router.push("/login");
  },

  //
  //
  created() {},
  //
  //
  //
  beforeMounted() {},
  //
  //
  //
  mounted() {
    if (localStorage.getItem("accessToken") === null) {
      return;
    }

    // Redirect to admin's dashboard
    if (localStorage.getItem("role") === "User") {
      this.$router.push("/dashboard-user");
      return;
    } else if (localStorage.getItem("role") === "Admin") {
      if (localStorage.getItem("type") === "AdminSystem") {
        this.$router.push("/dashboard-admin-system");
        return;
      } else if (localStorage.getItem("type") === "Admin") {
        this.$router.push("/dashboard-admin");
        return;
      }
    }

    // Update data
    this.getStats();
    this.$refs.aclTable.requestData();
  },
  //
  //
  //
  beforeUpdated() {},
  //
  //
  //
  updated() {},
  //
  //
  //
  beforeDestroy() {},
  //
  //
  //
  destroyed() {},
  //
  //
  //
  methods: {
    //
    //
    //
    isMobile() {
      return tools.isMobile();
    },
    //
    //
    //
    async getStats() {
      // Student
      let response = null;
      response = await axios.get(
        process.env.VUE_APP_INVENTORY_API + "/users/total",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        }
      );
      this.stats[0].value = response.data.amount;
      // Guest
      response = await axios.get(
        process.env.VUE_APP_INVENTORY_API + "/guests/total",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        }
      );
      this.stats[1].value = response.data.amount;
      // Room
      response = await axios.get(
        process.env.VUE_APP_INVENTORY_API + "/rooms/total",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("accessToken")
          }
        }
      );
      this.stats[2].value = response.data.amount;
    }
  }
};
</script>

<style lang="scss"></style>
